import { Button, ButtonLink } from "../../design-system";
import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { SocialMedia } from "../index";
import { useAuth } from "../../context/AuthContext";

function Header() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header>
      <nav className="relative z-[5] flex min-h-[70px] items-center justify-between border-b border-border bg-header px-[max(24px,calc((100vw-1380px)/2))] py-2 max-[640px]:flex-wrap max-[640px]:justify-center max-[640px]:gap-0.5 max-[640px]:px-4 max-[640px]:pb-3" aria-label="Main navigation">
        <a className="flex items-center gap-2.5 text-lg font-black tracking-[.18em] text-foreground no-underline max-[640px]:w-full max-[640px]:justify-center [&_img]:block [&_img]:h-12 [&_img]:w-[clamp(128px,13vw,175px)] [&_img]:object-contain max-[640px]:[&_img]:h-[42px] max-[640px]:[&_img]:w-[150px]" href="#top" aria-label="Vismal, back to top">
          <img src="/images/vismal_contorno_white.png" alt="Vismal" />
        </a>
        <div className="flex items-center gap-[clamp(15px,2.5vw,35px)] max-[640px]:w-full max-[640px]:flex-wrap max-[640px]:justify-center max-[640px]:gap-x-[17px] max-[640px]:gap-y-1 [&_a]:py-2.5 [&_button]:py-2.5 [&_a]:text-eyebrow [&_button]:text-eyebrow [&_a]:font-extrabold [&_button]:font-extrabold [&_a]:tracking-[.18em] [&_button]:tracking-[.18em] [&_a]:uppercase [&_button]:uppercase [&_a]:text-navigation [&_button]:text-navigation [&_a:hover]:text-navigation-hover [&_button:hover]:text-navigation-hover max-[640px]:[&_a]:pt-2 max-[640px]:[&_a]:pb-0.5 max-[640px]:[&_a]:text-caption max-[640px]:[&_button]:pt-2 max-[640px]:[&_button]:pb-0.5 max-[640px]:[&_button]:text-caption">
          <a href="#news">Novidades</a>
          <a href="#shows">Shows</a>
          <a href="#music">Music</a>
          {isAuthenticated ? (
            <>
              <RouterLink to="/playlist">Media</RouterLink>
              <Button variant="ghost" size="none" onClick={handleLogout}>Sair</Button>
            </>
          ) : (
            <RouterLink to="/login">Login</RouterLink>
          )}
        </div>
      </nav>
      <div className="relative isolate grid min-h-[min(690px,74vw)] place-items-center overflow-hidden bg-hero bg-[url('../../public/images/vismal_2025.webp')] bg-cover bg-[position:center_38%] max-[640px]:min-h-[510px]" id="top">
        <video className="pointer-events-none absolute inset-0 -z-[2] h-full w-full object-cover motion-reduce:hidden" autoPlay loop muted playsInline poster="/images/vismal_2025.webp" aria-hidden="true">
          <source src="/videos/intro.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 -z-[1] h-full w-full bg-[linear-gradient(90deg,rgba(11,9,9,.7),rgba(11,9,9,.26)_50%,rgba(11,9,9,.7)),linear-gradient(0deg,rgb(var(--color-background))_0%,transparent_27%,transparent_65%,rgba(0,0,0,.5))]" />
        <div className="w-[min(900px,calc(100%-40px))] pb-[78px] pt-[70px] text-center max-[640px]:pb-[76px] max-[640px]:pt-[58px]">
          <p className="mb-[22px] text-eyebrow font-extrabold tracking-eyebrow text-kicker max-[640px]:mb-[18px]">SÃO PAULO · BRAZIL</p>
          <img className="mx-auto block max-h-[220px] w-[min(680px,85%)] object-contain drop-shadow-[0_12px_24px_#000] max-[640px]:w-[min(100%,440px)]" src="/images/vismal_contorno_white.png" alt="Vismal" />
          <p className="mb-[27px] mt-2 text-eyebrow font-extrabold tracking-eyebrow text-tagline max-[640px]:text-[9px] max-[640px]:leading-normal max-[640px]:tracking-[.2em]">DEATH METAL FROM THE UNDERGROUND</p>
          <div className="mb-[22px] flex flex-wrap justify-center gap-3 max-[640px]:gap-[9px]">
            <ButtonLink size="action" className="min-w-[180px] max-[640px]:min-w-[145px]" href="#music">MUSIC <span aria-hidden="true">↗</span></ButtonLink>
            <ButtonLink variant="overlay" size="action" className="min-w-[180px] max-[640px]:min-w-[145px]" href="#shows">SHOWS<span aria-hidden="true">↓</span></ButtonLink>
          </div>
          <SocialMedia />
        </div>
        {/* <div className="absolute bottom-6 left-[max(24px,calc((100vw-1380px)/2))] right-[max(24px,calc((100vw-1380px)/2))] flex justify-between text-[9px] font-extrabold tracking-eyebrow text-hero-meta max-[640px]:bottom-[15px] max-[640px]:left-[18px] max-[640px]:right-[18px] max-[640px]:text-[8px]"><span>EST. 2003</span><span>SCROLL TO EXPLORE ↓</span></div> */}
      </div>
    </header>
  );
}

export default Header;
